import { useLocation } from "react-router-dom";
import FooterInformation from "../../components/FooterInformation/FooterInformation";

function FooterInformationContainer() {
	const location = useLocation();

	return <FooterInformation section={location.hash} />;
}

export default FooterInformationContainer;
